export default __webpack_public_path__ + "static/media/button_upload_zh_cn.22109b94.svg";